import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button } from 'semantic-ui-react'
import { connectForm, ModalForm, Group, Form, Field, Submit, InfoGroup, Info } from '~/form'
import { editPerson } from '../actions'
import moment from 'moment'

class PeopleEdit extends Component {
  static formSubmit(dispatch, formId, values, changed) {
    dispatch(editPerson(formId, values.get('id'), values.toJS()))
  }

  static formValidation = {
    'data.name': ['required'],
    email: ['required', 'email'],
  }

  componentWillMount = () => {
    let { formInit, person } = this.props
    formInit(person)
  }

  render() {
    let { formUpdate, formSubmit, formState, formLoading, onClose, person, project } = this.props
    let interviews = Map()
    let hasProject = Map.isMap(project)

    if (hasProject) interviews = project.get('interviews', Map())

    let actions = <Button size="tiny" color="green" content="Tallenna" icon="save" />

    return (
      <ModalForm id="person-edit" onSubmit={formSubmit} formState={formState} actions={actions} onClose={onClose}>
        <Group title="Muokkaa henkilön tietoja">
          <InfoGroup>
            <Info
              label="Luotu"
              text={moment(person.get('created_at'), 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')}
            />
            <Info
              label="Päivitetty"
              text={moment(person.get('updated_at'), 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')}
            />
          </InfoGroup>
          <Field
            label="Status"
            type="radios"
            name="status"
            options={[
              { label: 'Odottaa käsittelyä', value: 'pending' },
              { label: 'Soita myöhemmin uudestaan', value: 'callback' },
              { label: 'Tulee mukaan', value: 'accepted' },
              { label: 'Kieltäytyy', value: 'declined' },
            ]}
            onChange={formUpdate}
            formState={formState}
          />
          {interviews.size ? (
            <Field
              label="Kohdista haastatteluun"
              type="select"
              name="interview_id"
              options={interviews
                .map(i => ({ value: i.get('id'), text: `${i.get('name')} (${i.get('people', List()).size})` }))
                .unshift({ value: null, text: 'Ei haastattelua' })
                .toArray()}
              onChange={formUpdate}
              formState={formState}
            />
          ) : null}
          <Field label="Nimi" type="text" name="data.name" onChange={formUpdate} formState={formState} />
          <Field label="Sähköposti" type="email" name="email" onChange={formUpdate} formState={formState} />
          <Field label="Puhelinnumero" type="text" name="data.phone" onChange={formUpdate} formState={formState} />
          <Field label="Muistiinpanot" type="textarea" name="data.notes" onChange={formUpdate} formState={formState} />
        </Group>
      </ModalForm>
    )
  }
}

function mapStateToProps(state) {
  return {
    project: state.activeProject || Map(),
  }
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connectForm('person-edit', PeopleEdit, mapStateToProps, mapDispatchToProps)
